import columns from '../../../../../react-table/helpers/columns';

export const countryCodeConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { sender } = rowInfo.row;
    const countryCode = rowInfo.row['consignmentId.countryCode'];
    if (!sender || (sender.slice(0, 2) !== countryCode)) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    ExternalCountryCodeConcatenatedConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Recipient', 'recipient'),
        new TextColumn('Recipient mailbox', 'recipientMailbox'),
        new TextColumn('INTREF', 'intRef'),
        new DateColumn('INTREF preparation date', 'intRefPreparationDate'),
      ],
    },
    {
      Header: 'Consignment ID',
      columns: [
        new TextColumn('Country code', 'consignmentId.countryCode')
          .withGetProps(countryCodeConditionalProps),
        new ExternalCountryCodeConcatenatedConsignmentLinkColumn(new TextColumn('Identifier', 'consignmentId.identifier')
          .withWidth(275)),
      ],
    },
  ];
};
